import React, { useState } from "react";
import { ClipLoader } from 'react-spinners';
import { SERVER_URL } from "../../constants";
import {useAuth} from "@clerk/clerk-react";

const ProfileImage = ({image}) => {
    const [profileImage, setProfileImage] = useState(image);
    const [loading, setLoading] = useState(false);
    const {getToken} = useAuth();
  
    const handleImageChange = async(e) => {
      const file = e.target.files[0];
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append("user", file);

        const token = await getToken();

        const res=await fetch(`${SERVER_URL}/api/v1/user/update-profile-picture`,{
          method: 'POST',
          credentials: 'include',
          headers: {
            "Authorization": `Bearer ${token}`,
          },
          body: formData,
        })
        const result=await res.json();
        console.log(result)
        if(!result.success)
        {
            throw new Error(result.message)
        }
        setProfileImage(result.data.img_url)
        setLoading(false)
      }
    };

    if (loading) {
      return (
        <div className="flex justify-center items-center">
          <ClipLoader size={50} color={"#123abc"} loading={loading} />
        </div>
      );
    }
  
    return (
      <div className="relative">
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />
        {profileImage ? (
          <img
            src={profileImage}
            alt="Profile"
            className="w-full h-full object-cover rounded-full"
          />
        ) : (
          <span className="text-3xl">JD</span>
        )}
      </div>
    );
  }

  export default ProfileImage;